import { AppRoleEnum } from '@ulysses-inc/harami_api_client'

export const roleLabels: Record<AppRoleEnum, string> = {
  [AppRoleEnum.OWNER]: '管理者',
  [AppRoleEnum.EDITOR]: '編集者',
  [AppRoleEnum.LEADER]: 'リーダー',
  [AppRoleEnum.REPORTER]: 'レポート作成者',
}

export const roleOptions: [AppRoleEnum, string][] = [
  [AppRoleEnum.OWNER, roleLabels[AppRoleEnum.OWNER]],
  [AppRoleEnum.EDITOR, roleLabels[AppRoleEnum.EDITOR]],
  [AppRoleEnum.LEADER, roleLabels[AppRoleEnum.LEADER]],
  [AppRoleEnum.REPORTER, roleLabels[AppRoleEnum.REPORTER]],
]
